import { useTranslation } from 'react-i18next';
import { OrgFilterByEnum, type OrgFilterBy } from 'src/types';

type Props = {
  handleClick: () => void;
  filterBy: OrgFilterBy;
  setFilterBy: (filterBy: OrgFilterBy) => void;
};

export const FilterItems = ({ handleClick, filterBy, setFilterBy }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      {Object.keys(OrgFilterByEnum).map((filter, i) => {
        return (
          <button
            key={`filter-${i}`}
            className={`w-full whitespace-nowrap py-0.5 text-left transition-all ${
              filterBy === filter
                ? 'text-primary-dark hover:text-primary'
                : 'text-primary hover:text-primary-dark'
            }`}
            name={filter}
            onClick={(e) => {
              setFilterBy(e.currentTarget.name as keyof typeof OrgFilterByEnum);
              handleClick();
            }}
          >
            {t(`org_settings.filter.${filter}`)}
          </button>
        );
      })}
    </>
  );
};
